import { useUserContext } from '@/api/hooks/useUserContext';
import {
  canInScope,
  resolveAbility,
  type CaslAction,
  type CaslSubject,
  type ClientAbility,
} from '@/lib/ability';
import { useRestaurantStore } from '@/stores/restaurant.store';
import { useMemo } from 'react';

export function useAbility(): ClientAbility {
  const { data: ctx } = useUserContext();
  const storeContext = useRestaurantStore((s) => s.userContext);
  const context = ctx ?? storeContext;
  return useMemo(() => resolveAbility(context), [context]);
}

export function useCan(action: CaslAction, subjectType: CaslSubject): boolean {
  const ability = useAbility();
  const restaurantId = useRestaurantStore((s) => s.selectedRestaurantId);
  const franchiseId = useRestaurantStore((s) => s.selectedFranchiseId);
  return canInScope(ability, action, subjectType, { restaurantId, franchiseId });
}
